import { render, staticRenderFns } from "./my-menu.vue?vue&type=template&id=124fab70&scoped=true&"
import script from "./my-menu.vue?vue&type=script&lang=js&"
export * from "./my-menu.vue?vue&type=script&lang=js&"
import style0 from "./my-menu.vue?vue&type=style&index=0&id=124fab70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124fab70",
  null
  
)

export default component.exports